module.exports = __webpack_public_path__ + "img/new_logo2.9d53da36.png";